<template>
  <div style="text-align: center;">
    <div style="border: 1px solid #dddddd; padding: 20px 0 28px;border-radius: 4px;">
      <p><el-checkbox v-model="identity" :disabled="identityDis">去身份认证</el-checkbox></p>
      <p><el-checkbox v-model="zhima" :disabled="zhimaDis">去人脸识别</el-checkbox></p>
      <p><el-checkbox v-model="video" :disabled="videoDis">去视频认证</el-checkbox></p>
      <div class="dialog-footer" style="text-align: center;">
        <el-button @click.native="cancel">取消</el-button>
        <el-button type="primary" @click.native="submit" v-loading="submitLoading" v-show="!(this.identityDis && this.zhimaDis && this.videoDis)">提交</el-button>
      </div>
<!--      <div style="margin-top: 20px;text-align: left;">-->
<!--        <el-checkbox v-if="model == 1 || model == 2 || model == 3" v-model="handled"><span style="font-size: 13px;">该举报标为“已处理”</span></el-checkbox>-->
<!--        <el-checkbox v-if="model == 1" v-model="sentMsg" style="white-space: normal"><span style="font-size: 13px;">发送通知给举报人：【匿名举报反馈】非常感谢你的举报，我们已对涉嫌违规账户进行了调查和处罚</span></el-checkbox>-->
<!--      </div>-->
    </div>
    <p style="font-weight: bold;padding: 24px 0 6px;">系统指定认证</p>
    <p>去身份认证：<el-switch v-model="cancelIdentityAuth" :disabled="identityDis" @change="changeState(1, cancelIdentityAuth)"></el-switch></p>
    <p>去人脸识别：<el-switch v-model="cancelZhimaAuth" :disabled="zhimaDis" @change="changeState(2, cancelZhimaAuth)"></el-switch></p>
    <p>去视频认证：<el-switch v-model="cancelVideoAuth" :disabled="videoDis" @change="changeState(3, cancelVideoAuth)"></el-switch></p>
  </div>
</template>

<script>
import { postFormData } from '@/api/api';
import { updateResumeRecheckAuth, updateResumeCancelAuth } from '@/api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      identity: this.value.identity == 1 ? true : false,
      zhima: this.value.zhima == 1 ? true : false,
      video: this.value.video == 1 ? true : false,
      identityDis: this.value.identityState == 2 ? true : false,
      zhimaDis: this.value.zhimaCertifyState == 1 || this.value.baiduState == 1 ? true : false,
      videoDis: this.value.videoState == 2 ? true : false,
      cancelIdentityAuth: this.value.cancelIdentityAuth == 0 ? true : false,
      cancelZhimaAuth: this.value.cancelZhimaAuth == 0 ? true : false,
      cancelVideoAuth: this.value.cancelVideoAuth == 0 ? true : false,

      // id: this.value.id,
      userId: this.value.userId,
      // toUserId: this.value.toUserId,
      // handled: this.value.handled?true:false,
      // model: this.value.model,
      // sentMsg: this.value.sentMsg?true:false,

      submitLoading: false
    }
  },
  methods: {
    cancel() {
      this.$emit('close')
    },

    submit() {
      this.submitLoading = true;
      let param = {};
      // param['id'] = this.handled?this.id:'0';
      param['id'] = this.userId;
      // param['toUserId'] = this.sentMsg?this.toUserId:'0';
      // param['model'] = this.model;
      param['recheckAuthVideo'] = this.video ? 1 : 0;
      param['recheckAuthZhima'] = this.zhima ? 1 : 0;
      param['recheckAuthIdentity'] = this.identity ? 1 : 0;
      postFormData(updateResumeRecheckAuth, param).then((data) => {
        if(data.code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'success'
          })
          this.$emit('confirm', param);
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          })
        }
        this.submitLoading = false;
      })
          .catch(() => {
            this.submitLoading = false;
          })
    },

    // 系统指定认证
    changeState(type, state) {
      let param = {};
      param['id'] = this.userId;
      param['type'] = type;
      param['state'] = state ? 0 : 1;
      postFormData(updateResumeCancelAuth, param).then((data) => {
        if(data.code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'success'
          })
          this.$emit('confirm', param);
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>
